import React from 'react';
import { Button, Form, FormInstance, Input } from 'antd';
import { useTranslation } from 'react-i18next';

export interface ChangePasswordFormValues {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

interface Props {
  form: FormInstance<ChangePasswordFormValues>;
  submitting: boolean;
  onSubmit: (values: ChangePasswordFormValues) => void;
}

export const ChangePassword: React.FC<Props> = ({ form, submitting, onSubmit }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      <Form
        form={form}
        layout="vertical"
        className="flex-1 px-3 pt-2 floatingForm"
        requiredMark={false}
        onFinish={onSubmit}
      >
        <div className="floating-item relative">
          <Form.Item
            label={t('tai-khoan.change-password.old', 'Mật khẩu cũ')}
            name="currentPassword"
            rules={[
              { required: true, message: t('tai-khoan.change-password.old.required', 'Vui lòng nhập mật khẩu cũ') },
            ]}
          >
            <Input.Password size="large" placeholder="Mật khẩu cũ" className="h-[56px]" />
          </Form.Item>
        </div>

        <Form.Item
          label={t('tai-khoan.change-password.new', 'Mật khẩu mới')}
          name="newPassword"
          rules={[
            { required: true, message: t('tai-khoan.change-password.new.required', 'Vui lòng nhập mật khẩu mới') },
            { min: 8, message: t('tai-khoan.change-password.new.min', 'Mật khẩu cần tối thiểu 8 ký tự') },
          ]}
        >
          <Input.Password size="large" placeholder={t('tai-khoan.change-password.new.placeholder', 'Mật khẩu mới')} className="h-[56px]" />
        </Form.Item>

        <Form.Item
          label={t('tai-khoan.change-password.confirm', 'Nhập lại mật khẩu mới')}
          name="confirmPassword"
          dependencies={['newPassword']}
          rules={[
            {
              required: true,
              message: t('tai-khoan.change-password.confirm.required', 'Vui lòng nhập lại mật khẩu mới'),
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(t('tai-khoan.change-password.confirm.not-match', 'Mật khẩu nhập lại không khớp'))
                );
              },
            }),
          ]}
        >
          <Input.Password
            size="large"
            placeholder={t('tai-khoan.change-password.confirm.placeholder', 'Nhập lại mật khẩu mới')}
            className="h-[56px]"
          />
        </Form.Item>

        {/* Mô tả hướng đặt mật khẩu */}
        <div className="text-[11px] text-black uppercase mb-2 tracking-wide font-bold">
          {t('tai-khoan.change-password.description', 'Hướng dẫn đặt mật khẩu mới')}
        </div>
        <div className="text-[12px] text-black">
          {t('tai-khoan.change-password.description-content', 'Mật khẩu phải có 8-12 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt, không quá dễ đoán.')}
        </div>

        <div className='pt-4'>
          <Button
            size="large"
            type="primary"
            htmlType="submit"
            loading={submitting}
            className="!bg-[#111827] hover:opacity-80 border-none !h-[44px] w-full !font-bold !text-[14px]"
          >
            {t('bsc.btn.xacnhan', 'Xác nhận')}
          </Button>
        </div>
      </Form>
    </div>
  );
};
